import { EntityBase } from './EntityBase';
import { TypeTitle } from './TypeTitle';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class TypeStudy extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   typeStudyId: string;
   typeTitleId: number;
   studyLong: string;
   environmentalStudy: boolean;
   effectsRequired: boolean;
   rowVersion: number;
   typeTitle: TypeTitle;
}

